import { createFileRoute } from '@tanstack/react-router';
import { RecurringDonationsAdmin } from '@/components/finance';

// ADR-069 (#616) — the platform-admin Recurring Cutoff surface. Under the Settings sub-nav, Manage-gated
// in the sub-nav (the route stays reachable by direct URL; the component gates its wind-down actions and
// the API enforces Finance/Manage).
export const Route = createFileRoute('/admin/finance/settings/recurring')({
  component: RecurringDonationsAdmin,
});
